import { TextsetContextProvider } from '@/contexts/TextSetContext/entry';
import { SetsSelectedWrapper } from './SetsSelectedWrapper';
import { StackScreenProps } from '@react-navigation/stack';
import { TherapistStackParamList } from '@/navigations/TherapistStack';

export default function TextSet(
  props: StackScreenProps<TherapistStackParamList, 'TextSet'>,
) {
  const { setId, selectedID, apiName } = props.route?.params ?? {};

  return (
    <TextsetContextProvider
      setId={setId}
      patientId={selectedID}
      apiName={apiName}
    >
      <SetsSelectedWrapper props={props} />
    </TextsetContextProvider>
  );
}
